import Recipient from "@/components/core/subComponents/Recipient";
import { setCurrentTransactionField } from "@/state/transactions/CurrentTransactionEvents";
import { ModelMail } from "@/type/core/models/models.types";
import useMessageSection from "@/utils/hooks/useMessageSection";
import useRecipient from "@/utils/hooks/useRecipient";
import SubmitButton from "@components/core/buttons/SubmitButton";
import InputFormField from "@components/core/inputs/InputFormField";
import SignatureMailForm from "@components/core/subComponents/SignatureMailForm";
import { formValidateTriggers } from "@utils/Constant";
import { Col, Form, Row } from "antd";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

interface ScellementMessageSectionProps {
  officeId?: string;
  className?: string;
  endOfTransaction?: ModelMail;
}

const ScellementMessageSection: FunctionComponent<
  ScellementMessageSectionProps
> = ({ officeId, className = "", endOfTransaction }) => {
  const { t } = useTranslation();

  const [isEndTransactionMailChanged, setIsEndTransactionMailChanged] =
    useState(false);

  const {
    office,
    contacts,
    members,
    extraRecipients,
    setExtraRecipients,
    handleAddMe,
  } = useRecipient(officeId);

  const {
    form,
    endOfTransactionSignatureInitialValue,
    setEndOfTransactionSignatureInitialValue,
    endOfTransactionMailForm,
    endOfTransactionMailFormValues,
    submittable,
    initialValues,
  } = useMessageSection({
    endOfTransaction,
    isFromModel: false,
  });

  const handleSubmit = () => {
    const reference: string = form.getFieldValue("object");
    const endOfTransactionModelMail: ModelMail = {
      ...endOfTransaction,
      mailConfiguration: {
        ...endOfTransactionMailFormValues,
      },
      defaultModel: endOfTransactionMailFormValues.defaultModel,
    };

    setCurrentTransactionField([
      {
        field: "reference",
        value: reference,
      },
      {
        field: "endOfTransaction",
        value: isEndTransactionMailChanged
          ? endOfTransactionModelMail
          : undefined,
      },
      {
        field: "endOfTransactionModelMailId",
        value: endOfTransaction?.id,
      },
    ]);
  };

  return (
    <Row
      className={`app-section-message-scellement justify-content-center ${className}`}
    >
      <Col span={24} lg={20} xl={16}>
        <Form
          form={form}
          onFinish={handleSubmit}
          initialValues={initialValues}
          {...formValidateTriggers}
          layout="vertical"
        >
          <InputFormField
            showLabel
            showTooltip
            labelTooltip="transactionReference"
            module="scellement.accordion.messageForm"
            field="object"
            maxLength={45}
            labelClassName="label-tertiary"
          />
          {/* TODO: Temporary fix to initialize form => Refacto by using single form at root level */}
          <Form
            form={endOfTransactionMailForm}
            {...formValidateTriggers}
            layout="vertical"
          >
            <SignatureMailForm
              form={endOfTransactionMailForm}
              mailType={"endOfTransaction"}
              officeId={officeId}
              transactionType="scellement"
              isFromScellement
              className="pt-24"
              sealEndOfTransactionMailName={endOfTransaction?.name}
              sealEndOfTransactionMailOfficeOrUserName={
                endOfTransaction?.officeOrUserName
              }
              signatureInitialValue={endOfTransactionSignatureInitialValue}
              setSignatureInitialValue={
                setEndOfTransactionSignatureInitialValue
              }
              triggerFormChanged={() => setIsEndTransactionMailChanged(true)}
            />
          </Form>
          {office && (
            <Recipient
              className="mt-48 border-top-secondary pt-24"
              office={office}
              onAddMe={handleAddMe}
              contacts={contacts}
              members={members}
              recipients={extraRecipients}
              setRecipients={setExtraRecipients}
              isFromScellement
            />
          )}
          <div className="d-flex align-items-center justify-content-end flex-wrap gap-8 pt-30">
            <SubmitButton
              disabled={!submittable}
              label={"scellement.accordion.last.validate"}
              className="mw-160"
              title={
                !submittable
                  ? t("signature.accordion.last.missingObject")
                  : undefined
              }
            />
          </div>
        </Form>
      </Col>
    </Row>
  );
};

export default ScellementMessageSection;
